import React, { useEffect } from 'react';
import { Box } from '@bluedolphin/ui';
import { AccountManager, Util } from '@bluedolphin/util-module-mf';
import SideNavBar from '../../components/atoms/SideNavBar';
import Profile from './user-profile';

export const ProfileWrapper = () => {
    const { rootURL, token } = AccountManager.getTenant();
    useEffect(() => {
        if (token && Util.JWT.isExpired(token)) {
            return window.history.pushState({}, '', `${rootURL}login`);
        }
    }, []);

    return token && !Util.JWT.isExpired(token) ? (
        <Box display="flex" height={'100%'}>
            <SideNavBar />
            <Profile />
        </Box>
    ) : null;
};
